import { Col, Form, Row, Typography, message } from "antd";
import React, { useEffect, useState } from "react";
import { MODE } from "../constant";
import { changeFormatdate } from "../../../utils/formatDate";
import BtnEditUC from "../../../components/Form/BtnEditUC";
import BtnDeleteUC from "../../../components/Form/BtnDeleteUC";
import DatePickerUC from "../../../components/Form/DatePickerUC";
import CheckBoxUC from "../../../components/Form/CheckBoxUC";
import InputUC from "../../../components/Form/InputUC";
import InputNumberUC from "../../../components/Form/InputNumberUC";
import ButtonUC from "../../../components/buttonUC";
import TextAreaUC from "../../../components/Form/TextAreaUC";
import HeaderBarAdd from "../headerBarAdd";
import dayjs from "dayjs";
const moment = require('moment');

const Experience = ({ props }) => {
    const {
        form,
        rcAppProfileExp,
        setRcAppProfileExp,
        rcDeletedData,
        setRcDeletedData,
    } = props;

    const { Text } = Typography;
    const [mode, setMode] = useState(MODE.VIEW); //view, edit
    const isMobile = window.innerWidth <= 768;

    // const isCurrentWatch = Form.useWatch('exp_isCurrent', form);
    const [isCurrentWatch, setCurrentWatch] = useState(false);
    const [isReq, setReq] = useState(false);

    useEffect(() => {
        setReq(mode === MODE.EDIT);
    }, [mode]);

    const handleAdd = () => {
        console.log("handleAdd");
        // new
        let newRow = {
            sort: 1,
            startDate: null,
            endDate: null,
            isCurrent: false,
            employer: null,
            jobTitle: null,
            salary: null,
            description: null,
            reason: null,
        };

        if (rcAppProfileExp && rcAppProfileExp.length > 0) {
            const max = Math.max(...rcAppProfileExp.map((o) => o.sort));
            newRow = {
                ...newRow,
                sort: max + 1,
            };
        }

        setForm(newRow);
        setMode(MODE.EDIT);
        setCurrentWatch(false);
    };
    const onchange = (ev) => {
        let value = ev.target.value;
        const val = parseFloat(value.replace(/,/g, "")).toLocaleString();
        value = val === "NaN" ? "" : val;
        form.setFieldsValue({ exp_salary: value });
    };
    const setForm = (record) => {
        setCurrentWatch(record.isCurrent);
        const _salary = record.salary
            ? parseFloat(record.salary.replace(/,/g, "")).toLocaleString()
            : null;
        form.setFieldsValue({
            exp_sort: record.sort,
            exp_startDate: record.startDate ? dayjs(record.startDate) : null,
            exp_endDate: record.endDate ? dayjs(record.endDate) : null,
            exp_isCurrent: record.isCurrent,
            exp_employer: record.employer,
            exp_jobTitle: record.jobTitle,
            exp_salary: _salary,
            exp_description: record.description,
            exp_reason: record.reason,
        });
    };

    const handleEdit = (record) => {
        console.log("handleEdit", record);
        if (record) {
            setForm(record);
            setMode(MODE.EDIT);
        }
    };

    const handleDelete = (record) => {
        if (record.id) {
            // เก็บ Record ที่ลบ
            setRcDeletedData([
                ...rcDeletedData,
                { id: record.id, tableName: "appProfileExp" },
            ]);
        }
        setRcAppProfileExp(rcAppProfileExp.filter((r) => r.sort !== record.sort));
    };

    const handleCancel = () => {
        setMode(MODE.VIEW);
    };

    const handleSubmit = () => {
        console.log("handleSubmit");
        let dataColValidate = [
            { caption: "กรุณาเลือกวันที่เริ่มต้น", columnName: "exp_startDate" },
            { caption: "กรุณากรอกสถานที่ทำงาน", columnName: "exp_employer" },
            { caption: "กรุณากรอกตำแหน่งงาน", columnName: "exp_jobTitle" },
            { caption: "กรุณากรอกเงินเดือน", columnName: "exp_salary" },
            { caption: "กรุณากรอกลักษณะการทำงาน", columnName: "exp_description" },
            { caption: "กรุณากรอกเหตุผลที่ออก", columnName: "exp_reason" },
        ];
        if (!form.getFieldValue("exp_isCurrent")) {
            dataColValidate.push({
                caption: "กรุณาเลือกวันที่สิ้นสุด",
                columnName: "exp_endDate",
            });
        }
        const dataPreSubmit = {
            sort: form.getFieldValue("exp_sort"),
            startDate: form.getFieldValue("exp_startDate"),
            endDate: form.getFieldValue("exp_endDate"),
            isCurrent: form.getFieldValue("exp_isCurrent"),
            employer: form.getFieldValue("exp_employer"),
            jobTitle: form.getFieldValue("exp_jobTitle"),
            salary: form.getFieldValue("exp_salary"),
            description: form.getFieldValue("exp_description"),
            reason: form.getFieldValue("exp_reason"),
        };

        let isValidate = false;
        dataColValidate.forEach((el) => {
            const _isValidate = checvalidateDraft(el);
            isValidate = isValidate ? isValidate : _isValidate ?? false;
        });

        if (isValidate) {
            message.warning("กรุณากรอกข้อมูลประสบการณ์การทำงาน");
            return false;
        } else {
            const row = rcAppProfileExp.filter(
                (item) => item.sort === dataPreSubmit.sort
            );
            if (row && row.length > 0) {
                setRcAppProfileExp(
                    rcAppProfileExp.map((obj) =>
                        obj.sort === dataPreSubmit.sort ? { ...obj, ...dataPreSubmit } : obj
                    )
                );
            } else {
                console.log("[...rcAppProfileExp, dataPreSubmit]", [
                    ...rcAppProfileExp,
                    dataPreSubmit,
                ]);
                setRcAppProfileExp([...rcAppProfileExp, dataPreSubmit]);
            }

            setMode(MODE.VIEW);
        }
    };

    const checvalidateDraft = (e) => {
        const _data = form.getFieldValue([e.columnName]);
        if (!_data || _data === "") {
            form.setFields([
                {
                    name: [e.columnName],
                    errors: [e.caption],
                },
            ]);
            return true;
        }
        return false;
    };

    const getDateDiff = (date1, date2) => {
        const startDate = moment(date1);
        const endDate = moment(date2);

        let years = endDate.diff(startDate, 'years');
        startDate.add(years, 'years');

        let months = endDate.diff(startDate, 'months');
        startDate.add(months, 'months');

        let days = endDate.diff(startDate, 'days');

        months += Math.floor((days + 1) / 30)
        days = (days + 1) % 30

        years += Math.floor(months / 12)
        months = months % 12
        return { years, months, days };
    };

    const FormView = ({ data }) => {
        const startDate = new Date(data.startDate);
        const endDate = data.isCurrent === true ? new Date() : new Date(data.endDate);
        const exp = getDateDiff(startDate, endDate);
        let startDateText = changeFormatdate(data.startDate);
        let endDateText =
            data.isCurrent === true ? "ปัจจุบัน" : changeFormatdate(data.endDate);
        if (data.isCurrent !== true) {
            endDateText = `${endDateText}`;
        }

        let textExp = `${exp.years} ปี ${exp.months} เดือน ${exp.days} วัน`;

        return (
            <>
                <Row className="py-2 p-3">
                    <Col xs={24} md={8} className="px-2 flex items-center">
                        <Text className="text-job-title color-secondary1">
                            {data.jobTitle}
                        </Text>
                    </Col>
                    <Col xs={24} md={12} className="px-2 flex items-center">
                        <Text className="text-employer mr-3">{data.employer}</Text>
                        <Text className="text-date">{`${startDateText} - ${endDateText} (${textExp})`}</Text>
                    </Col>
                    <Col xs={24} md={4} className="px-2">
                        <div className="flex justify-end">
                            <BtnEditUC
                                disabled={data.isCanNotEdit === true}
                                handleEdit={() => handleEdit(data)}
                            />
                            <BtnDeleteUC
                                disabled={data.isCanNotDelete === true}
                                handleDelete={() => handleDelete(data)}
                            />
                        </div>
                    </Col>
                </Row>
            </>
        );
    };

    const handleChangeIsCurrent = (e) => {
        const checked = e.target.checked ?? false;
        form.setFieldValue("exp_endDate", null);
        setCurrentWatch(checked);
    };

    const setDisabledDate = (current, colName) => {
        let _startDate = form.getFieldValue("exp_startDate");
        let _endDate = form.getFieldValue("exp_endDate");
        const _date = convertToDate(current);
        if (colName === "start") {
            const dateNow = convertToDate(new Date());
            if (_endDate) {
                _endDate = convertToDate(_endDate);
                return _date > _endDate || _date > dateNow;
            } else {
                return _date > dateNow;
            }
        } else if (colName === "end") {
            if (_startDate) {
                _startDate = convertToDate(_startDate);
                return _date < _startDate;
            }
        }
    };

    const convertToDate = (val) => {
        let _date = val ? new Date(val) : new Date();
        _date.setHours(0, 0, 0, 0);
        return _date;
    };

    const FormEdit = () => {
        return (
            <>
                <Row className="py-2">
                    <Col span={0} className={"hidden"}>
                        <Text name={"exp_sort"}></Text>
                    </Col>
                    <Col xs={24} md={8} className="px-2">
                        <DatePickerUC
                            label="วันที่เริ่มต้น"
                            name={"exp_startDate"}
                            disabledDate={(curr) => setDisabledDate(curr, "start")}
                            required={isReq}
                        />
                    </Col>
                    <Col xs={24} md={8} className="px-2">
                        <DatePickerUC
                            required={!isCurrentWatch}
                            label="วันที่สิ้นสุด"
                            name={"exp_endDate"}
                            showPlaceholder={!isCurrentWatch}
                            disabled={isCurrentWatch}
                            disabledDate={(curr) => setDisabledDate(curr, "end")}
                        />
                    </Col>
                    <Col
                        xs={24}
                        md={8}
                        className={`px-2 flex ${isMobile ? "justify-start" : "justify-center"
                            } items-center div-checkbox`}
                    >
                        <CheckBoxUC
                            label="ที่ทำงานปัจจุบัน"
                            name={"exp_isCurrent"}
                            onChange={handleChangeIsCurrent}
                        />
                    </Col>
                </Row>
                <Row className="py-2">
                    <Col span={24} className="px-2">
                        <InputUC
                            required={isReq}
                            maxLength={255}
                            label="สถานที่ทำงาน"
                            name={"exp_employer"}
                        />
                    </Col>
                </Row>
                <Row className="py-2">
                    <Col xs={24} md={16} className="px-2">
                        <InputUC
                            required={isReq}
                            maxLength={255}
                            label="ตำแหน่งงาน"
                            name={"exp_jobTitle"}
                        />
                    </Col>
                    <Col xs={24} md={8} className="px-2">
                        <InputUC
                            required={isReq}
                            maxLength={10}
                            label="เงินเดือน"
                            name={"exp_salary"}
                            suffix="บาท"
                            onChange={onchange}
                        />
                    </Col>
                </Row>
                <Row className="py-2">
                    <Col span={24} className="px-2">
                        <TextAreaUC
                            required={isReq}
                            label="ลักษณะการทำงาน"
                            placeholder="กรุณากรอกลักษณะการทำงาน"
                            name={"exp_description"}
                            maxLength={1000}
                        />
                    </Col>
                </Row>
                <Row className="py-2">
                    <Col span={24} className="px-2">
                        <TextAreaUC
                            required={isReq}
                            label="เหตุผลที่ออก"
                            placeholder="กรุณากรอกเหตุผลที่ออก"
                            name={"exp_reason"}
                        />
                    </Col>
                </Row>
                <Row className="py-2">
                    <Col span={24} className="px-2 flex justify-end">
                        <ButtonUC className="btn-clear mr-3" onClick={() => handleCancel()}>
                            ยกเลิก
                        </ButtonUC>
                        <ButtonUC
                            className="btn-custom ml-3"
                            onClick={() => handleSubmit()}
                        >
                            บันทึก
                        </ButtonUC>
                    </Col>
                </Row>
            </>
        );
    };

    return (
        <div className="experience content-block p-3">
            {/* <div className="block-title">ประสบการณ์การทำงาน</div> */}
            <HeaderBarAdd
                title={"ประสบการณ์การทำงาน"}
                handleAdd={handleAdd}
                disabled={mode === "edit"}
                titleClassName="color-primary"
                headerBarClassName={
                    (rcAppProfileExp && rcAppProfileExp.length > 0) || mode === "edit"
                        ? "custom-header-bar"
                        : ""
                }
            />
            {mode === "view" && rcAppProfileExp && rcAppProfileExp.length > 0 ? (
                <>
                    {rcAppProfileExp.map((item, index) => {
                        return <FormView key={index} data={item} />;
                    })}
                </>
            ) : (
                <>{mode === "edit" && <FormEdit />}</>
            )}
        </div>
    );
};

export default Experience;
